<template>
    <div id="app">
        <i-know />
    </div>
</template>

<script>
import iKnow from "./components/iKnow.vue";

export default {
    name: "app",
    components: {
        iKnow
    }
};
</script>

<style lang="scss">

</style>
